import {
    Breadcrumb as ShadBreadcrumb,
    BreadcrumbList,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbSeparator,
    BreadcrumbPage,
} from "@/shared/ui/breadcrumb"
import { Link, useLocation } from "react-router-dom"

export type Crumb = {
    label: string
    href?: string
}

interface BreadcrumbProps {
    items?: Crumb[]
}

export function Breadcrumb({ items }: BreadcrumbProps) {
    const location = useLocation()

    const pathnames = location.pathname.split("/").filter(Boolean)

    const autoItems: Crumb[] = pathnames.map((segment, index) => {
        const href = "/" + pathnames.slice(0, index + 1).join("/")
        return {
            label: segment.charAt(0).toUpperCase() + segment.slice(1),
            href: index < pathnames.length - 1 ? href : undefined,
        }
    })

    const finalItems = items ?? autoItems

    return (
        <ShadBreadcrumb>
            <BreadcrumbList>
                {finalItems.map((item, index) => {
                    const isLast = index === finalItems.length - 1
                    return (
                        <BreadcrumbItem key={index}>
                            {item.href && !isLast ? (
                                <>
                                    <BreadcrumbLink asChild>
                                        <Link to={item.href} className="text-white hover:text-white/80">{item.label}</Link>
                                    </BreadcrumbLink>
                                    <BreadcrumbSeparator className="text-white" >/</BreadcrumbSeparator>
                                </>
                            ) : (
                                <BreadcrumbPage className="text-white">{item.label}</BreadcrumbPage>
                            )}
                        </BreadcrumbItem>
                    )
                })}
            </BreadcrumbList>
        </ShadBreadcrumb>
    )
}
